/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The distributor of the rewards.
 */
export enum Distributor {
    MERKL = 'MERKL',
}
